import axios from "@/lib/axios";
import { createFileRoute, redirect } from "@tanstack/react-router";
import type { UserOrganization } from "@/components/user-context";

export const Route = createFileRoute("/")({
  loader: async () => {
    try {
      const [, orgsResponse] = await Promise.all([
        axios.get("/bff/user"),
        axios.get<UserOrganization[]>("/api/organizations"),
      ]);

      if (orgsResponse.data.length === 0) {
        throw redirect({ to: "/onboarding", search: { add: false } });
      }

      throw redirect({ to: "/dashboard" });
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return;
      }
      throw error;
    }
  },
});
